<script lang="ts" setup></script>

<template>
  <div class="border-t border-primary/20" />
</template>

<style scoped></style>
